"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const NewsletterSharedItemFragment_1 = __importDefault(require("./NewsletterSharedItemFragment"));
const NewsletterFragment = (0, graphql_tag_1.default) `
  fragment newsletter on Newsletter {
    origin
    invalidEmail
    invalidName
    default {
      ...sharedItems
    }
    success {
      ...sharedItems
    }
    error {
      ...sharedItems
    }
  }
  ${NewsletterSharedItemFragment_1.default}
`;
exports.default = NewsletterFragment;
